"use client";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex, Grid, Typography } from "antd/lib";
import Bugsnag from "@bugsnag/js";

const { Title } = Typography;

const { useBreakpoint } = Grid;

const CHUNK_RELOAD_KEY = "chunkReloadAt";
const CHUNK_RELOAD_WINDOW_MS = 10000;

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const clickHandler = () => {
    if (typeof window === "undefined") return;

    window.location.reload();
  };

  useEffect(() => {
    const isChunkError = error.name === "ChunkLoadError" || error.message.includes("Loading chunk");

    if (isChunkError && typeof window !== "undefined") {
      const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;

      if (Date.now() - lastReloadAt > CHUNK_RELOAD_WINDOW_MS) {
        window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
        window.location.reload();
        return;
      }
    }

    Bugsnag.notify(error);
  }, [error]);

  return (
    <Flex gap={24} vertical justify="center" align="center">
      <Title level={1} style={{ textAlign: "center" }}>
        {t("common.messages.somethingWentWrong")}
      </Title>

      <Button type="primary" onClick={clickHandler} style={{ width: screens.sm ? "auto" : "100%" }}>
        {t("common.actions.reload")}
      </Button>
    </Flex>
  );
}
